import { render, staticRenderFns } from "./server-shen.vue?vue&type=template&id=566b5b8b&scoped=true"
import script from "./server-shen.vue?vue&type=script&lang=js"
export * from "./server-shen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566b5b8b",
  null
  
)

export default component.exports